import { render, staticRenderFns } from "./ServiceCheckpointsList.vue?vue&type=template&id=66d82ecf"
import script from "./ServiceCheckpointsList.vue?vue&type=script&lang=js"
export * from "./ServiceCheckpointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports